export const capitalize = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const capitalizeAndJoin = (...names) => {
    const validNames = names.filter(name => name && name.trim() !== '');
    const capitalizedNames = validNames.map(name => capitalize(name));
    return capitalizedNames.join(' ');
};
